import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fire",
  "use": "icon-fire-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"https://www.w3.org/2000/svg\" xmlns:xlink=\"https://www.w3.org/1999/xlink\" id=\"icon-fire\">\n  <path d=\"M789.1 258.7C666 293.7 643.6 393 652 456c-88.2-103.5-84-221.1-84-391.8C286.7 170.6 352.5 475.6 344.1 568c-70-57.4-84-195.9-84-195.9C186 409.9 148.2 513.4 148.2 596c0 201.5 162.3 363.8 363.8 363.8S875.8 797.5 875.8 596c0-119-88.1-175-86.7-337.3z\" p-id=\"17645\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fire.svg
// module id = M/uk
// module chunks = 12